module.exports = {
  FIXED: 'fixed',
  RATIO: 'ratio',
  DEBIT: 'debit',
};
